export enum AdUnit {
  adhesion = 'adhesion_video',
  sticky = 'sticky_video',
  video = 'video'
}

export default AdUnit
